export { default } from './PartiuGpComoParticipar';
